import { FormattedMessage } from "@/i18n/i18n-client";
import { UserIcon } from "@/assets/Icons/UserIcon";
import { Mail01Icon } from "@/assets/Icons/Mail01Icon";
import { MobileChatIcon } from "@/assets/Icons/MobileChatIcon";
import { WhatsAppIcon } from "@/assets/Icons/WhatsAppIcon";
import { DefaultPhoneMethod } from "@/generated/graphql";
import { LoginMethod } from "@/templates/types/LoginFormProps";
import DoubleCircleIcon from "@/components/DoubleCircleIcon";
import { Login04Icon } from "@/assets/Icons/Login04Icon";

export enum ModalStep {
  login = "LOGIN",
  otp = "OTP",
  signup = "SIGNUP",
}

interface ModalHeaderProps {
  step: ModalStep;
  method: LoginMethod;
  phoneMethod: DefaultPhoneMethod | undefined | null;
  receiver: string;
  watchValue: (field: string) => any;
  notVerifiedEmail?: string | null;
  notVerifiedPhone?: string | null;
}

const ModalHeader = ({
  step,
  method,
  phoneMethod,
  receiver,
  watchValue,
  notVerifiedEmail,
  notVerifiedPhone,
}: ModalHeaderProps) => {
  const getIcon = () => {
    if (step === ModalStep.login) {
      return <DoubleCircleIcon icon={<Login04Icon />} />;
    } else if (step === ModalStep.signup) {
      return <DoubleCircleIcon icon={<UserIcon />} />;
    } else if (method === LoginMethod.EMAIL) {
      return <DoubleCircleIcon icon={<Mail01Icon />} />;
    } else if (phoneMethod === DefaultPhoneMethod.Sms) {
      return <DoubleCircleIcon icon={<MobileChatIcon />} />;
    } else {
      return <DoubleCircleIcon icon={<WhatsAppIcon />} />;
    }
  };

  const getTitle = () => {
    if (step === ModalStep.login) {
      return (
        <FormattedMessage
          defaultMessage="Sign in to your account"
          id="BBzsfa"
        />
      );
    } else if (step === ModalStep.signup) {
      return (
        <FormattedMessage defaultMessage="Tell us more about you" id="iaBEFa" />
      );
    } else if (method === LoginMethod.EMAIL) {
      return (
        <FormattedMessage
          defaultMessage="Please check your email."
          id="/qzy3E"
        />
      );
    } else if (phoneMethod === DefaultPhoneMethod.Sms) {
      return (
        <FormattedMessage
          defaultMessage="We've sent an OTP via SMS."
          id="Aj2BZx"
        />
      );
    } else {
      return (
        <FormattedMessage
          defaultMessage="We've sent an OTP via Whatsapp"
          id="X+VOOX"
        />
      );
    }
  };

  const getSubtitle = () => {
    if (step === ModalStep.signup) {
      return null;
    } else if (step === ModalStep.login) {
      return (
        <FormattedMessage
          defaultMessage="Welcome! Please enter your details"
          id="qiwHKb"
        />
      );
    } else if (method === LoginMethod.EMAIL) {
      return (
        <FormattedMessage
          defaultMessage="We've sent a code to {email}"
          id="/3NQdv"
          values={{
            email: notVerifiedEmail || receiver || watchValue("email"),
          }}
        />
      );
    } else {
      return (
        <FormattedMessage
          defaultMessage="Enter the code sent to <b>{phonNumber}</b>"
          id="FR6ozE"
          values={{
            phonNumber:
              notVerifiedPhone || receiver || watchValue("phonNumber"),
            b: (chunks) => <b>{chunks}</b>,
          }}
        />
      );
    }
  };

  return (
    <div className="flex flex-col justify-between items-center gap-4 w-full">
      {getIcon()}
      <div className="flex flex-col justify-between items-center gap-1 w-full">
        <span className="text-gray-900 text-display-xs font-semibold ">
          {getTitle()}
        </span>

        {getSubtitle() && (
          <span className="!text-gray-600 text-base font-normal ">
            {getSubtitle()}
          </span>
        )}
      </div>
    </div>
  );
};

export default ModalHeader;
